import {observer} from 'mobx-react';
import {noop} from 'shared/tools';
import {FormattedMessage, injectIntl} from 'react-intl';
import {ActionLink, FilterDropdown, Input, RadioButtonGroup, RadioButton} from 'shared/components';

const SingleInputFilter = observer(({viewModel}) => {
  if (viewModel.isRangeOperator) return null;
  const {value} = viewModel.editingRow;

  return (
    <Input value={value} onChange={(e) => viewModel.updateInput(e.target.value)}/>
  );
});

const RangeInputFilter = observer(({viewModel}) => {
  if (!viewModel.isRangeOperator) return null;
  const {lower_bound, upper_bound} = viewModel.editingRow.range;

  return (
    <div className='clearfix table'>
      <div className='col-5 table-cell align-middle'>
        <Input
          value={lower_bound}
          onChange={(e) => viewModel.updateInputStartRange(e.target.value)}
        />
      </div>
      <div className='col-1 table-cell align-middle center px2'>
        <FormattedMessage id='reports.to'/>
      </div>
      <div className='col-5 table-cell align-middle'>
        <Input
          value={upper_bound}
          onChange={(e) => viewModel.updateInputEndRange(e.target.value)}
        />
      </div>
    </div>
  );
});

const InputFilterRow = injectIntl(observer(({uiState, viewModel, intl}) => {
  const { editingRow } = viewModel;

  return (
    <div className='py1 flex align-items-start gap-1'>
      <FilterDropdown isOpen={false}
                      onOpen={noop}
                      onCancel={noop}
                      selected={[intl.formatMessage({id: `reports.${viewModel.category}`})]}
                      disabled={true}/>
      <FilterDropdown isOpen={viewModel.operatorOpen}
                      onOpen={() => { uiState.closeFilters(); viewModel.openOperator(); }}
                      onCancel={() => viewModel.closeOperator()}
                      selected={[intl.formatMessage({id: `reports.${viewModel.operatorView(editingRow.operator)}`})]}
                      onApply={() => { viewModel.updateRow(); uiState.applyFilters(); }}>
        <RadioButtonGroup name={`${viewModel.category}_operator`}
                          onChange={(name, value) => viewModel.editOperator(value)}
                          selectedValue={editingRow.operator}>
          {viewModel.operators.map(o =>
            <RadioButton className='block pb1' key={o} value={o}><FormattedMessage id={`reports.${viewModel.operatorView(o)}`}/></RadioButton>
          )}
        </RadioButtonGroup>
      </FilterDropdown>
      <FilterDropdown isOpen={viewModel.inputOpen}
                      onOpen={() => { uiState.closeFilters(); viewModel.openInput(); }}
                      onCancel={() => viewModel.closeInput()}
                      selected={viewModel.isRangeOperator ? viewModel.inputRangeView : viewModel.inputView}
                      onApply={() => { viewModel.updateRow(); uiState.applyFilters(); }}
                      placeholder={''}
                      separator={<FormattedMessage id='reports.to' />}>
        <div className='mb1'>
          <SingleInputFilter viewModel={viewModel}/>
          <RangeInputFilter viewModel={viewModel}/>
        </div>
      </FilterDropdown>
      <ActionLink onClick={() => uiState.toggleFilterRow(viewModel.category, false)} className='meadow align-self-center'>
        <i className='material-icons h3 align-middle'>{'close'}</i>
      </ActionLink>
    </div>
  );
}));

export default InputFilterRow;
